<template>
  <div>
    <div class="d-flex justify-content-end mb-2">
      <b-button size="sm" variant="primary" @click="openAdd">
        + Add Trip Document
      </b-button>
    </div>
    <b-table
      :items="value"
      :fields="fields"
      small
      responsive
      style="min-height: 400px"
    >
      <template #cell(index)="{ index }">{{ index + 1 }}</template>
      <template #cell(file)="{ item }">
        <b-button
          variant="secondary"
          v-if="item.fileUrl"
          @click="openTripDoc(item)"
        >
          <i class="fa fa-download" aria-hidden="true"></i>
          Download
        </b-button>
        <span v-else>-</span>
      </template>
      <template #cell(action)="{ index }">
        <b-dropdown right size="sm" text="Action" variant="outline-primary">
          <b-dropdown-item @click="edit(index)">Edit</b-dropdown-item>
          <b-dropdown-item class="text-danger" @click="remove(index)">
            Delete
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <b-modal v-model="showModal" title="Trip Document" @ok="save">
      <b-form-group label="Document Name">
        <b-form-input v-model="form.documentName" required />
      </b-form-group>
      <b-form-group label="Detail Trip Number">
        <b-form-select
          v-model="form.detailTripNumber"
          :options="detailTripOptions"
          placeholder="Select detail trip number"
        />
      </b-form-group>
      <b-form-group label="File">
        <b-form-file v-model="form.file" accept=".pdf,.jpg,.png" />
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'TripDocumentTable',
  props: {
    value: { type: Array, default: () => [] },
    dataProject: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showModal: false,
      editIndex: null,
      form: {
        documentName: '',
        detailTripNumber: '',
        file: null,
        fileName: '',
      },
      fields: [
        { key: 'index', label: 'NO', class: 'w-1' },
        { key: 'documentName', label: 'Document Name' },
        { key: 'detailTripNumber', label: 'Detail Trip Number' },
        { key: 'file', label: 'File' },
        { key: 'action', label: 'Action', class: 'text-right' },
      ],
      apiUrl: process.env.VUE_APP_API_BUSDEV_BASE_URL,
    }
  },
  mounted() {
    console.log(this.dataProject, 'dataProject')
  },
  computed: {
    detailTripOptions() {
      const plans = this.dataProject?.detail_plan || []
      // Prefer number_detail_plan if present, else try common alternatives
      return plans.map((p, idx) => {
        return {
          value: p?.id,
          text: p?.shipment_plan_detail_number,
        }
      })
    },
  },
  methods: {
    async openTripDoc(item) {
      try {
        const fileUrl = item?.fileUrl || ''
        const url = `${this.apiUrl}/download/${fileUrl.replace('upload/', '')}`
        const axios = this.$store?.state?.authAxios || this.$axios || this.$http
        const res = await axios.get(url, { responseType: 'blob' })
        const blobUrl = URL.createObjectURL(res.data)
        window.open(blobUrl, '_blank')
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000)
      } catch (err) {
        this.$bvToast?.toast(err?.message || 'Failed to download document', {
          variant: 'danger',
        })
      }
    },
    openAdd() {
      this.editIndex = null
      this.form = {
        documentName: '',
        detailTripNumber: '',
        file: null,
        fileName: '',
      }
      this.showModal = true
    },
    edit(i) {
      this.editIndex = i
      const it = this.value[i]
      this.form = {
        documentName: it.documentName,
        detailTripNumber: it.planId,
        file: null,
        fileName: it.fileName,
      }
      this.showModal = true
    },
    remove(i) {
      const arr = this.value.slice()
      arr.splice(i, 1)
      this.$emit('input', arr)
    },
    async save() {
      // Build multipart/form-data payload for API via Vuex action createTripDocument
      const fd = new FormData()
      fd.append('name_document', this.form.documentName || '')
      fd.append('plan_id', this.form.detailTripNumber || '')
      const contractId =
        this.dataProject?.id || this.dataProject?.project_contract_id
      if (contractId) fd.append('project_contract_id', contractId)
      if (this.form.file) fd.append('files', this.form.file)

      const payload = { data: fd }
      try {
        let res = null
        if (this.editIndex !== null) {
          payload.id = this.value[this.editIndex].id
          res = await this.$store.dispatch(
            'busdev/updateTripDocument',
            payload
          )
        } else {
          res = await this.$store.dispatch(
            'busdev/createTripDocument',
            payload
          )
        }
        if (res?.status === 'success') {
          this.$emit('refresh')
          this.showModal = false
        } else {
          this.$bvToast?.toast('Failed to create trip document', {
            variant: 'danger',
          })
        }
      } catch (e) {
        this.$bvToast?.toast('Error creating trip document', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
